import { useTypeSafeMutation } from '@oresundsbron/api';
import { ValidationResult } from '@oresundsbron/use-form';
import { alprParser } from '@oresundsbron/validators';
import { pipe } from 'fp-ts/lib/function';
import { fold, tryCatchK, fromTask } from 'fp-ts/lib/TaskOption';
import { of } from 'fp-ts/lib/Task';
import { useCallback } from 'react';
import { z } from 'zod';

type AlprBody = z.input<typeof alprParser>;

export function useValidateAlpr() {
  const { mutateAsync } = useTypeSafeMutation(
    ['validate', 'alpr'],
    (req) => req.Alpr.validate
  );

  return useCallback(
    <T>(validationResult: ValidationResult<T>) =>
      (body: AlprBody) =>
        pipe(
          body,
          tryCatchK(mutateAsync),
          fold(
            () => of(validationResult),
            () => of(undefined)
          ),
          fromTask
        ),
    [mutateAsync]
  );
}

//This sikps the weird fpts stuff and just lets you get and handle the results in a simpler way
export async function useValidateAlpr2() {
  const { mutateAsync } = useTypeSafeMutation(
    ['validate', 'alpr'],
    (req) => req.Alpr.validate
  );
  return useCallback((body: AlprBody) => mutateAsync(body), [mutateAsync]);
}
